module.exports = __webpack_public_path__ + "img/form-6.8fe0b913.svg";